<template>
  <div class="room-enter">
    <div class="mtitle">{{classesInfo.classesName}}</div>
    <div class="content">
      <div class="mleft">
        <template v-if="classesInfo.classesType == 0 || classesInfo.classesType == 3">
          <video class="local-live" :src="classesInfo.videoUrl | fileFilter" controls ref="localVideo"
            @play="ManageVideo" @pause="VideoScollbar"></video>
          <div class="frce btns">
              <el-button type="primary" v-if="classesInfo.materialsUrl" v-on:click="openFile(classesInfo.materialsUrl)">课程资料</el-button>
              <el-button type="danger" v-on:click="roomEnd">退出学习</el-button>
          </div>
        </template>
        <template v-if="classesInfo.classesType == 1">
          <div class="local-live" id="remoteStream"></div>
          <div class="frce btns">
            <el-button :type="audioSelfFlag ? 'primary' : 'danger'" @click="closeAudioSelf">{{audioSelfFlag ? "禁麦" :
              "开麦"}}</el-button>
            <el-button type="primary" v-if="classesInfo.materialsUrl" v-on:click="openFile(classesInfo.materialsUrl)">课程资料</el-button>
            <el-button type="danger" v-on:click="roomEnd">退出直播</el-button>
          </div>
        </template>
      </div>
      <div class="chat-area" v-if="classesInfo.classesType != 0">
        <ul class="show-area">
          <template v-for="item in liveMessage">
            <li>
              <img class="icon-c" src="@/assets/avator11.png" alt="">
              <div>
                <p><span class="text-b">{{item.userName}}</span> <span class="text-c">{{item.time}}</span></p>
                <p class="text-d">{{item.content}}</p>
              </div>
            </li>
          </template>
        </ul>
        <div class="input-area">
          <el-input type="textarea" resize="none" ref="textarea" rows="3" v-model="message"></el-input>
          <div class="frce btnsb">
            <el-button type="primary" @click="submitFormMsg">发送</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TRTCUtilStudent from "@/utils/TRTCUtilStudent";
  import CommonFilters from "@/mixins/CommonFilters";
  import HttpConnectionB from "@/utils/HttpConnectionB";
  import WebSocketUtil from "@/utils/WebSocketUtil";
  let videoInterval = null;
  let studentHeartInterval = null;
  export default {
    name: "RoomEnter",
    mixins: [CommonFilters],
    components: {},
    data () {
      return {
        audioSelfFlag: true,
        message: "",
        classesInfo: {},
        trackSourceConfig: ["audio", "video"],
        curTime: 0,  // 当前播放时间
        scollorbar:0, // 拖动后的时间 
        state: true, // 直播聊天状态
        count: 0, // 录播暂停计时
        Rate:1, // 播放速度
      };
    },
    computed: {
      liveMessage () {
        return this.$store.state.app.liveMessage;
      },
      userInfo () {
        return this.$store.state.user.userInfo;
      }
    },
    mounted () {
      let that = this;
      let _classInfo = sessionStorage.getItem("classInfo");
      that.classesInfo = JSON.parse(_classInfo);
      console.log(that.classesInfo);
      if (that.classesInfo.classesType == 0 && that.userInfo.roleId == 101) { // 课时类型为录播，并且是学生用户
        // console.log(that.classesInfo);
        that.$nextTick(function () {
          videoInterval = setInterval(function () {
            that.recordProgress();
          }, 3000);
          that.fastForward();
        });
      } else if (that.classesInfo.classesType == 3 && that.userInfo.roleId == 101) { // 课时类型为直播回放，并且是学生用户
        that.$nextTick(function () {
          videoInterval = setInterval(function () {
            that.recordProgress();
          }, 3000);
        });
      } else if (that.classesInfo.classesType == 1 && that.userInfo.roleId == 101) { // 课时类型为直播，并且是学生用户
        that.roomEnter();
        studentHeartInterval = setInterval(function () {
          HttpConnectionB.get("/rtc/room/heart/beats", {
            params: {
              classId: that.classesInfo.classId,
              classesId: that.classesInfo.classesId
            }
          }).then(res => {
            that.state = res.msg
          }).catch(err => {
            console.log(err);
          })
        }, 5000)
      } else if (that.classesInfo.classesType == 1 && that.userInfo.roleId == 100) { // 课时类型为直播，并且是教员用户
        that.roomEnter();
      }
    },
    watch:{
      scollorbar(val) {
        let vd = this.$refs.localVideo;
        let Oval = localStorage.getItem('curTime');
        if(val - Oval > 0){
          vd.currentTime = Oval;
        }
      },
      Rate(val){
        let vd = this.$refs.localVideo;
        if(val != 1){
          vd.playbackRate = 1;
        }
      }
    },
    methods: {
      roomEnter () {
        let that = this;
        that.HttpConnection.get("/rtc/room/get", {
          params: { scheduleId: that.classesInfo.scheduleId }
        }).then(function (response) {
          let _temp = response.data;
          _temp.userId = "" + that.userInfo.userId;
          TRTCUtilStudent.loginTRTC("remoteStream", _temp);
        });
        /*
        that.HttpConnection.post("/rtc/room/enter", {
            "userID": "101",
            "nickName": "teacher",
            "roomID": "15218"
        }).then(function(response) { });
         */
      },
      submitFormMsg () {
        let that = this;
        if (that.state == 'true') {
          HttpConnectionB.post("/chat/real-time/send-class", {
            cmd: 0,
            scheduleId: that.classesInfo.scheduleId,
            classId: that.classesInfo.classId,
            teacherId: that.classesInfo.teacherId,
            teacherName: that.classesInfo.teacherName,
            content: that.message
          }).then(function (response) {
            that.message = "";
          });
        } else {
          that.$message({
            type: "error",
            message: "直播聊天已关闭"
          });
        }
      },
      recordProgress () {
        let that = this;
        let _localVideo = that.$refs.localVideo;
        HttpConnectionB.post("/learn/history/save", {
          classesId: that.classesInfo.classesId,
          curVideoTime: _localVideo.currentTime,
          totalVideoTime: _localVideo.duration,
          classesType: that.classesInfo.classesType,
          userId: that.userInfo.userId
        }).then(function (response) { });
      },
      roomEnd () {
        // this.$router.back(-1);
        if (this.userInfo.roleId == 100) {
          this.$router.push({
            path: "/ManageEducation/TeacherSchedule"
          });
        }
        if (this.userInfo.roleId == 101) {
          this.$router.push({
            path: "/ManageStudy/StudentSchedule"
          });
        }
      },

      /*
      * 切换音频源
      * */
      changeAudioTap () {
        let _sourceTrackConfig = {};
        if (this.trackSourceConfig[0] == "audio" && this.trackSourceConfig[1] == "screen") {
          this.trackSourceConfig[0] = "screenAudio";
          _sourceTrackConfig[this.trackSourceConfig[0]] = true;
          _sourceTrackConfig[this.trackSourceConfig[1]] = true;
          TRTCUtilStudent.changeTrackSource(_sourceTrackConfig);
        } else if (this.trackSourceConfig[0] == "screenAudio" && this.trackSourceConfig[1] == "video") {
          this.trackSourceConfig[0] = "audio";
          _sourceTrackConfig[this.trackSourceConfig[0]] = true;
          _sourceTrackConfig[this.trackSourceConfig[1]] = true;
          TRTCUtilStudent.changeTrackSource(_sourceTrackConfig);
        }
      },
      /*
      * 共享屏幕
      * */
      shareScreenTap () {
        WebSocketUtil.sendWebSocket({
          cmd: 3,
          userId: this.classesInfo.teacherId, // 接受人
          sender: this.userInfo.userId, // 发送人
        });

        this.trackSourceConfig[1] = "screen";
        let _sourceTrackConfig = {};
        _sourceTrackConfig[this.trackSourceConfig[0]] = true;
        _sourceTrackConfig[this.trackSourceConfig[1]] = true;
        TRTCUtilStudent.changeTrackSource(_sourceTrackConfig);
      },
      /*
      * 开启视频
      * */
      openCameraTap () {
        WebSocketUtil.sendWebSocket({
          cmd: 3,
          userId: this.classesInfo.teacherId, // 接受人
          sender: this.userInfo.userId, // 发送人
        });
        this.trackSourceConfig[0] = "audio";
        this.trackSourceConfig[1] = "video";
        let _sourceTrackConfig = {};
        _sourceTrackConfig[this.trackSourceConfig[0]] = true;
        _sourceTrackConfig[this.trackSourceConfig[1]] = true;
        TRTCUtilStudent.changeTrackSource(_sourceTrackConfig);
      },
      closeAudioSelf () {
        if (this.audioSelfFlag) {
          TRTCUtilStudent.setMuteAudio();
        } else {
          TRTCUtilStudent.setUnmuteAudio();
        }
        this.audioSelfFlag = !this.audioSelfFlag;
      },
      // 当前视频进度
      fastForward () {
        let that = this;
        let vd = that.$refs.localVideo; //获取video对象
        setInterval(() => {
          this.curTime = vd.currentTime
          this.Rate = vd.playbackRate
          localStorage.setItem("curTime",this.curTime);
        }, 100);
      },
      // 视频拖动后的进度
      VideoScollbar(){
        let that = this;
        let vd = that.$refs.localVideo; //获取video对象
        that.scollorbar = vd.currentTime
      },
      // 视频超过十分钟暂停
      ManageVideo () {
        this.videoInterval()
      },
      videoInterval () {
        var that = this
        var videoTime = setInterval(() => {
          that.count++;
          if (that.count > 600) {
            that.$refs.localVideo.pause()
            that.$refs.localVideo.onpause = function () {
              that.count = 0;
              window.clearInterval(videoTime);
              alert("视频暂停播放,请点击继续");
            };
          }
        }, 1000);
        that.$refs.localVideo.onpause = function () {
          that.count = 0;
          window.clearInterval(videoTime);
        };
      },
      // 打开文件
      openFile(url){
        sessionStorage.setItem('fileUrl',`${process.env.VUE_APP_imagePath}${url}`)
        window.open(`/build/generic/web/viewer.html`) 
      }
    },
    beforeDestroy () {
      let that = this;
      if (that.classesInfo.classesType == 1 && that.userInfo.roleId == 101) {
        TRTCUtilStudent.logoutTRTC();
        clearInterval(studentHeartInterval);
      }
      clearInterval(videoInterval);
    },
  };
</script>

<style scoped lang="scss">
  .room-enter {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }

  .mtitle {
    height: 4vh;
    line-height: 4vh;
    text-align: center;
    background-color: #f4f8fb;
  }

  .content {
    height: 94vh;
    display: flex;
    justify-content: space-around;
    flex-direction: row;
  }

  .mleft {
    width: 80vw;
    padding: 1vw;
  }

  .chat-area {
    width: 20vw;
    border-left: 1px solid #e6e6e6;

    .show-area {
      height: 76vh;
      padding: 1vh;
      overflow-y: scroll;

      li {
        display: flex;
        flex-direction: row;
        margin: 6px 0px 0px 0px;
      }
    }

    .input-area {
      border-top: 1px solid #e6e6e6;
      padding: 10px;
      margin-top: 1vh;
    }
  }

  .local-live {
    width: 78vw;
    height: 85vh;
    overflow: hidden;
  }

  .btns {
    width: 78vw;
    margin-top: 1vh;
  }

  .btnsb {
    margin-top: 1.2vh;
  }

  .icon-c {
    width: 36px;
    height: 36px;
    margin-right: 8px;
  }

  .text-b {
    font-size: 12px;
    font-weight: 400;
    color: #666666;
  }

  .text-d {
    width: 213px;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: #ffffff;
    background-color: #91a9ff;
    padding: 7px;
    border-radius: 4px;
    margin: 4px 0px 0px 0px;
  }

  .text-c {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
  }

  /deep/ video::-webkit-media-controls-timeline {
    display: none;
  }
</style>